/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../Modal';
import { ControlTable } from '../../Table';
import useForm from '../../../hooks/useForm';
import { isEmpty, isFunction, trim } from 'lodash';
import { toast } from '../../../utils/toast';
import { getParams } from '../../../utils/params';
import Filters from '../../Filters';
import { USE_CONFIRM_TYPES, getCompaniesDetail, getDetailFields } from '../../../utils/taxPortal/companiesInfo';
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png";
import BankTable from '../../Bank/BankTable';
import Icon from '../../Icon';
import Badge from '../../Badge';
import { translation } from '../../../utils/translator';
import { BANK_TYPE } from '../../../constants/BANK_DATA';
import { getBankTransRecordList } from '../../../apis/finances/bank';
import { cloneDeep } from 'lodash';
import { cleanObj } from '../../../utils/cleanObj';
import NoData from '../../NoData/NoData';

const defaultForm = {
  offset: 0,
  limit: 10,
};

const TaxCompaniesInfoDetail = (props) => {
  const {
    open,
    setOpen,
    submit,
    selectedItem,
    setSelectedItem,
    params,
    detailType,
  } = props;

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setDetails({});
    submit && submit();
    if (selectedItem) {
      setSelectedItem(null);
    }
    resetForm();
    setBankParams({});
    setList([]);
    setTotal(0);
  };

  const [detailOpen, setDetailOpen] = useState(false);

  const [detailItem, setDetailItem] = useState(null);

  const [details, setDetails] = useState({});

  const [fields, setFields] = useState([]);

  const [bankParams, setBankParams] = useState({});

  const {
    form,
    resetForm,
    setSubmit,
    // handleSubmit,
    // LIST 용
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    filterSubmit,
    handleOnChange,
    reSubmit,
  } = useForm(defaultForm);

  useEffect(() => {
    getDetailSet(detailType);
  }, [detailType]);

  const getDetailSet = async (detailType) => {
    const details = await getCompaniesDetail(detailType, params);
    setDetails(details);
    setFields(getDetailFields(detailType));
  };


  useEffect(() => {
    if (!isEmpty(details) && isFunction(details?.api)) {
      setSubmit(_submit);
      _submit(form);
    }



  }, [details, params]);

  const _submit = async (form) => {
    if (!isEmpty(details?.bankParams)) {
      const _params = cloneDeep({ ...details?.bankParams, ...cleanObj({ ...form, ...params }) });
      setBankParams(_params);
    }

    setIsLoading(true)
    details.api(getParams({ ...form, ...params }))
      .then(res => {

        const { count, list } = res;
        setList([...list]);
        setTotal(count);
      })
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  };

  const _onSelect = (data, e) => {
    if (data?.deletedTime) {
      toast.success('삭제된 데이터입니다.');
      return;
    }
    setDetailItem(data);
    setDetailOpen(true);
  };

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
        size="x-lg"
      >
        <ModalHeader>
          {selectedItem && selectedItem.modalTitle}
        </ModalHeader>
        {details?.filters && (
          <Filters
            filters={details?.filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange}
          />
        )}
        {details?.type === "table" && (
          <ControlTable
            fields={fields}
            list={list}
            isLoading={isLoading}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            isHideControlHeader={true}
            isControl={false}
            onSelect={details?.isOnSelect ? _onSelect : details?.isOnSelect}
          />
        )}

        {
          details?.type === "bank_table" && (
            <>
              {!isEmpty(list) ? (
                list.map((bank, idx) => {
                  return (
                    <BankTable
                      key={idx}
                      bankList={list}
                      bankAccountIdx={bank.idx}
                      isUseConfirm={USE_CONFIRM_TYPES.includes(detailType)}
                      title={() => {
                        return (
                          <div>
                            <Icon className="bank-img-wrap" src={bank.bankImg || defaultBankImage} alt={bank.bankCompany} />
                            <Badge
                              className="margin-left-8"
                              color={bank.orgCd === 'pbk' ? "secondary" : 'warning'}
                              size="sm"
                              label={translation(BANK_TYPE, bank.orgCd)}
                            />
                            <span className="margin-left-8">
                              {`${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`}

                              {!isEmpty(bank.nickName) && trim(String(bank.nickName)) !== "" &&
                                `-[${trim(String(bank.nickName))}]`
                              }

                            </span>
                          </div>
                        );
                      }}
                      api={getBankTransRecordList}
                      params={bankParams}
                      permission={{ level: 9 }}
                      careCompanyIdx={params.companyIdx}
                    />
                  );
                })
              ) : (
                <>
                  <NoData text="여기야?" />
                </>
              )}
            </>
          )
        }
      </Modal>

      {details?.detailComponent && (
        details?.detailComponent({
          detailItem,
          setDetailItem,
          open: detailOpen,
          setOpen: setDetailOpen,
          submit: reSubmit,
          mode: "view",
        })
      )}
    </>
  );
};

export default TaxCompaniesInfoDetail;